import axios from "axios";
import dayjs from "dayjs";
import { ApiUrl } from "src/utils/ApiUrl";

export const SurchargeData = async () => {
  let getSurchargeData = axios.request({
    method: "GET",
    url: `${ApiUrl}/settings/vehicleTypeSurcharge`,
  });

  return getSurchargeData;
};

export const GetSurchargePrice = async () => {
  let getSurchargeData = await SurchargeData();
  let value = 0;
  getSurchargeData.data.forEach((item: any) => {
    if (item.key === "service_type_surcharge_price") {
      value = item.value;
    }
  });
  return value;
};

export const checkExtraCharge = async (date: Date) => {
  date = new Date(date);
  let startTime = "";
  let endTime = "";
  let bookingTime = new Date();
  bookingTime.setHours(date.getHours(), date.getMinutes(), 0);
  let bookingTimeString = dayjs(bookingTime).format("HH:mm:ss");
  let getSurchargeData = await SurchargeData();

  getSurchargeData.data.forEach((item: any) => {
    if (item.key === "service_type_surcharge_start_time") {
      date.setHours(item.value.split(":")[0], item.value.split(":")[1], 0);
      startTime = dayjs(date).format("HH:mm:ss");
    } else if (item.key === "service_type_surcharge_end_time") {
      date.setHours(item.value.split(":")[0], item.value.split(":")[1], 0);
      endTime = dayjs(date).format("HH:mm:ss");
    }
  });

  if (startTime > endTime) {
    if (bookingTimeString >= startTime || bookingTimeString <= endTime) {
      return true;
    } else {
      return false;
    }
  } else {
    if (bookingTimeString >= startTime && bookingTimeString <= endTime) {
      return true;
    } else {
      return false;
    }
  }
};
